"use strict";
module.exports = {
    entityModel: 'stockTaking',
    events: {
        STOCK_TAKING_COMPLETED: 'STOCK_TAKING_COMPLETED',
        STOCK_TAKING_STOCK_TAKEN: 'STOCK_TAKING_STOCK_TAKEN',
        STOCK_TAKING_UPDATED: 'STOCK_TAKING_UPDATED',
        STOCK_TAKING_CREATED: 'STOCK_TAKING_CREATED',
    },
    actions: {
        get: 'v1.stockTaking.get',
        list: 'v1.stockTaking.list',
        createStockTaking: 'v1.stockTaking.createStockTaking',
        markAsComplete: 'v1.stockTaking.markAsComplete',
        markNonCountedAsCounted: 'v1.stockTaking.markNonCountedAsCounted',
        takeStock: 'v1.stockTaking.takeStock',
        assignLocation: 'v1.stockTaking.assignLocation',
        setMissingPurchasePrices: 'v1.stockTaking.setMissingPurchasePrices',
        createInitialStockTaking: 'v1.stockTaking.createInitialStockTaking',
        upsert: 'v1.stockTaking.upsert',
        upsertWhenEmpty: 'v1.stockTaking.upsertWhenEmpty',
        updateWhenEmpty: 'v1.stockTaking.updateWhenEmpty',
        update: 'v1.stockTaking.update',
    },
    stockTakingStates: {
        created: 'created',
        locationsAssigned: 'locationsAssigned',
        countStarted: 'countStarted',
        stocksTaken: 'stocksTaken',
        pricesSet: 'pricesSet',
        completed: 'completed',
    },
    stockTakingRows: {},
};
